@if (isInstalled()) {
  <!-- Manage (installed): DS 2.1 slide-out cards -->
  <div class="tw-flex tw-flex-col tw-gap-4 tw-pb-6" data-testid="plugin-manage">
    <div class="tw-flex tw-items-center tw-gap-3.5">
      <span
        class="tw-flex tw-items-center tw-justify-center tw-size-11 tw-shrink-0 tw-rounded-[14px] tw-bg-color-surface-sunken tw-text-sm tw-font-semibold tw-text-color-text-secondary"
        >{{ monogram }}</span
      >
      <span
        class="tw-flex-1 tw-min-w-0 tw-truncate tw-text-xs tw-font-medium tw-text-color-text-tertiary"
        >{{ manageSubtitle }}</span
      >
      <span
        class="tw-flex tw-items-center tw-h-7 tw-px-3 tw-rounded-full tw-bg-color-status-success-bg tw-text-xs tw-font-semibold tw-text-color-status-success-text"
        >Installed</span
      >
    </div>

    @if (opensFeature || canEmbedConfig) {
      <div class="tw-flex tw-gap-3" data-testid="plugin-manage-actions">
        <app-gloss-button
          [options]="{
            text: (opensFeature ? 'open' : 'fetchData') | i18n,
            class: 'primary',
            onClick: (plugin()?.id === recurringDetectorPluginId
              ? openRecurringDetector
              : onUpdate
            ).bind(this),
            isEnabled: !isSubmitting(),
          }"
        ></app-gloss-button>
      </div>
    }

    <!-- EODHD re-enters its API key in its own card below, next to the button that saves it. -->
    @if ((hasCredentials && plugin()?.id !== eodhdPluginId) || plugin()?.supportsUserSwitch) {
      <div
        class="tw-flex tw-flex-col tw-gap-2.5 tw-p-4 tw-rounded-2xl tw-bg-white/45 tw-border tw-border-solid tw-border-white/40 tw-text-[13px] tw-leading-[1.5] tw-text-color-text-secondary"
        data-testid="plugin-manage-sign-in"
      >
        <span
          class="tw-text-[11px] tw-font-bold tw-uppercase tw-tracking-[0.08em] tw-text-color-text-tertiary"
          >{{ "pluginManageSignInAgain" | i18n }}</span
        >
        <span>{{ "pluginManageSignInAgainBody" | i18n: plugin()?.title }}</span>
        <div class="tw-flex tw-flex-wrap tw-items-center tw-gap-x-4 tw-gap-y-2">
          @if (canEmbedConfig) {
            <div class="tw-w-full" data-testid="plugin-manage-sign-in-form">
              <app-plugin-config
                [pluginId]="plugin().id"
                [embedded]="true"
                [forceReauth]="true"
                [submitLabel]="'pluginManageUpdatePassword' | i18n"
              ></app-plugin-config>
            </div>
          }
          @if (plugin()?.supportsUserSwitch) {
            <button
              type="button"
              class="tw-text-sm tw-font-semibold"
              [ngClass]="
                hasCredentials
                  ? 'tw-text-color-text-action'
                  : 'tw-h-10 tw-px-5 tw-rounded-xl tw-bg-color-intent-brand tw-text-color-text-on-action tw-shadow-elevation-control'
              "
              (click)="openPluginConfig()"
            >
              {{ "switchUser" | i18n }}
            </button>
          }
        </div>
      </div>
    }

    @if (showSync) {
      <div
        class="tw-flex tw-flex-col tw-gap-2.5 tw-p-4 tw-rounded-2xl tw-bg-white/45 tw-border tw-border-solid tw-border-white/40 tw-text-[13px] tw-leading-[1.5] tw-text-color-text-secondary"
        data-testid="plugin-manage-sync"
      >
        <span
          class="tw-text-[11px] tw-font-bold tw-uppercase tw-tracking-[0.08em] tw-text-color-text-tertiary"
          >{{ "pluginManageSync" | i18n }}</span
        >
        <div class="tw-grid tw-grid-cols-2 xs:tw-grid-cols-1 tw-gap-x-4 tw-gap-y-2.5">
          <div class="tw-flex tw-flex-col">
            <span class="tw-text-[11px] tw-font-semibold tw-text-color-text-tertiary">{{
              "pluginManageLastSynced" | i18n
            }}</span
            ><b class="tw-text-sm tw-font-medium tw-text-color-text-default">{{
              lastSyncedLabel
            }}</b>
          </div>
          <div class="tw-flex tw-flex-col">
            <span class="tw-text-[11px] tw-font-semibold tw-text-color-text-tertiary">{{
              "pluginManageAccounts" | i18n
            }}</span
            ><b class="tw-text-sm tw-font-medium tw-text-color-text-default">{{
              syncedAccountsLabel
            }}</b>
          </div>
          <div class="tw-flex tw-flex-col">
            <span class="tw-text-[11px] tw-font-semibold tw-text-color-text-tertiary">Version</span
            ><b class="tw-text-sm tw-font-medium tw-text-color-text-default">{{
              plugin()?.version || "1.0.0"
            }}</b>
          </div>
          <div class="tw-flex tw-flex-col">
            <span class="tw-text-[11px] tw-font-semibold tw-text-color-text-tertiary">Price</span
            ><b class="tw-text-sm tw-font-medium tw-text-color-text-default">{{
              plugin()?.price || "Free"
            }}</b>
          </div>
        </div>
      </div>
    }

    <div
      class="tw-flex tw-flex-col tw-gap-2.5 tw-p-4 tw-rounded-2xl tw-bg-white/45 tw-border tw-border-solid tw-border-white/40 tw-text-[13px] tw-leading-[1.5] tw-text-color-text-secondary"
    >
      <span
        class="tw-text-[11px] tw-font-bold tw-uppercase tw-tracking-[0.08em] tw-text-color-text-tertiary"
        >Overview</span
      >
      <span>{{ plugin()?.description }}</span>
    </div>

    <div
      class="tw-flex tw-flex-col tw-gap-2.5 tw-p-4 tw-rounded-2xl tw-bg-white/45 tw-border tw-border-solid tw-border-white/40 tw-text-[13px] tw-leading-[1.5] tw-text-color-text-secondary"
    >
      <span
        class="tw-text-[11px] tw-font-bold tw-uppercase tw-tracking-[0.08em] tw-text-color-text-tertiary"
        >{{ "pluginManageDetails" | i18n }}</span
      >
      <div class="tw-grid tw-grid-cols-2 xs:tw-grid-cols-1 tw-gap-x-4 tw-gap-y-2.5">
        @if (!showSync) {
          <div class="tw-flex tw-flex-col">
            <span class="tw-text-[11px] tw-font-semibold tw-text-color-text-tertiary">Version</span
            ><b class="tw-text-sm tw-font-medium tw-text-color-text-default">{{
              plugin()?.version || "1.0.0"
            }}</b>
          </div>
        }
        <div class="tw-flex tw-flex-col">
          <span class="tw-text-[11px] tw-font-semibold tw-text-color-text-tertiary">Developer</span
          ><b class="tw-text-sm tw-font-medium tw-text-color-text-action">{{ developerName }}</b>
        </div>
        @if (!showSync) {
          <div class="tw-flex tw-flex-col">
            <span class="tw-text-[11px] tw-font-semibold tw-text-color-text-tertiary">Price</span
            ><b class="tw-text-sm tw-font-medium tw-text-color-text-default">{{
              plugin()?.price || "Free"
            }}</b>
          </div>
        }
        <div class="tw-flex tw-flex-col tw-col-span-2 xs:tw-col-span-1">
          <span class="tw-text-[11px] tw-font-semibold tw-text-color-text-tertiary">Contact</span>
          @if (isBetaUser) {
            <a
              href="mailto:support@ironflytechnologies.com"
              class="tw-text-sm tw-font-medium tw-text-color-text-action tw-underline tw-break-all"
              >support&#64;ironflytechnologies.com</a
            >
          } @else {
            <b class="tw-text-sm tw-font-medium tw-text-color-text-action tw-break-all"
              >support&#64;ironflytechnologies.com</b
            >
          }
        </div>
      </div>
      <span
        class="tw-text-[11px] tw-font-bold tw-uppercase tw-tracking-[0.08em] tw-text-color-text-tertiary tw-pt-1"
        >Privacy &amp; permissions</span
      >
      @if (plugin()?.permissions && plugin().permissions.length > 0) {
        <ul class="tw-m-0 tw-list-disc tw-pl-5">
          @for (permission of plugin().permissions; track permission) {
            <li>{{ permission }}</li>
          }
        </ul>
      } @else {
        <span class="tw-text-color-text-tertiary tw-italic">No special permissions required.</span>
      }
    </div>

    @if (plugin()?.id === eodhdPluginId) {
      <div
        class="tw-flex tw-flex-col tw-gap-2.5 tw-p-4 tw-rounded-2xl tw-bg-white/45 tw-border tw-border-solid tw-border-white/40 tw-text-[13px] tw-leading-[1.5] tw-text-color-text-secondary"
      >
        <span class="tw-font-medium tw-text-color-text-default">{{
          "eodhdConfiguration" | i18n
        }}</span>
        <form [formGroup]="apiKeyForm" class="tw-flex tw-flex-col tw-gap-2">
          <div class="tw-flex tw-flex-col tw-gap-1">
            <label for="eodhdApiKey" class="tw-font-medium tw-text-sm tw-text-color-text-default">
              {{ "eodhdApiKeyLabel" | i18n }}
              <span class="tw-text-color-status-error-text">*</span>
            </label>
            <input
              id="eodhdApiKey"
              type="password"
              formControlName="apiKey"
              [placeholder]="'enterEodhdApiKey' | i18n"
              class="tw-px-3 tw-py-2 tw-border tw-border-solid tw-border-dt-border-primary tw-rounded-md focus:tw-outline-none focus:tw-ring-2 focus:tw-ring-color-icon-action"
              [class.!tw-border-color-status-error]="
                apiKeyForm.get('apiKey')?.invalid && apiKeyForm.get('apiKey')?.touched
              "
            />
            @if (apiKeyForm.get("apiKey")?.invalid && apiKeyForm.get("apiKey")?.touched) {
              <span class="tw-whitespace-nowrap tw-text-color-status-error-text tw-text-xs">{{
                "apiKeyIsRequired" | i18n
              }}</span>
            }
          </div>
        </form>
        <div>
          <button
            type="button"
            class="tw-h-10 tw-px-5 tw-rounded-xl tw-bg-color-intent-brand tw-text-sm tw-font-semibold tw-text-color-text-on-action tw-shadow-elevation-control"
            data-testid="plugin-manage-update"
            [disabled]="isSubmitting()"
            (click)="onUpdate()"
          >
            {{ "pluginManageUpdateKey" | i18n }}
          </button>
        </div>
      </div>
    }

    <!-- The extension's installed state comes from detection in the browser; a web page can't turn it off. -->
    @if (plugin()?.id !== glossExtensionPluginId) {
      <div
        class="tw-flex tw-flex-col tw-gap-2.5 tw-p-4 tw-rounded-2xl tw-bg-white/45 tw-border tw-border-solid tw-border-white/40 tw-text-[13px] tw-leading-[1.5] tw-text-color-text-secondary"
        data-testid="plugin-manage-status"
      >
        <span
          class="tw-text-[11px] tw-font-bold tw-uppercase tw-tracking-[0.08em] tw-text-color-text-tertiary"
          >{{ "pluginManageStatus" | i18n }}</span
        >
        <div class="tw-flex tw-items-center tw-gap-3">
          <div class="tw-flex tw-flex-col tw-flex-1">
            <b class="tw-text-sm tw-text-color-text-default">{{ "pluginManageEnabled" | i18n }}</b>
            <span>{{ "pluginManageEnabledHint" | i18n: plugin()?.title }}</span>
          </div>
          <button
            type="button"
            role="switch"
            aria-checked="true"
            [attr.aria-label]="'pluginManageEnabled' | i18n"
            class="tw-relative tw-w-[52px] tw-h-[30px] tw-shrink-0 tw-rounded-full tw-bg-color-intent-brand"
            [disabled]="isSubmitting()"
            (click)="onDisable()"
          >
            <span
              class="tw-absolute tw-top-[3px] tw-left-[3px] tw-size-6 tw-rounded-full tw-bg-white tw-shadow-md tw-translate-x-[22px]"
            ></span>
          </button>
        </div>
        @if (plugin()?.id === chatbotPluginId) {
          <div><app-chatbot></app-chatbot></div>
        }
      </div>
    }

    @if (isDataSource && !isSwitchPlugin) {
      <div
        class="tw-flex tw-flex-col tw-gap-2.5 tw-p-4 tw-rounded-2xl tw-border tw-border-solid tw-border-color-status-error-border tw-bg-color-status-error-bg tw-text-[13px] tw-text-color-text-secondary"
        data-testid="plugin-manage-disconnect"
      >
        <span
          class="tw-text-[11px] tw-font-bold tw-uppercase tw-tracking-[0.08em] tw-text-color-text-tertiary !tw-text-color-status-error-text"
          >{{ "pluginManageDisconnect" | i18n }}</span
        >
        <span>{{ "pluginManageDisconnectBody" | i18n: plugin()?.title }}</span>
        <div>
          <button
            type="button"
            class="tw-h-10 tw-px-5 tw-rounded-xl tw-border tw-border-solid tw-border-color-status-error-border tw-bg-color-surface-elevated tw-text-sm tw-font-semibold tw-text-color-status-error-text"
            [disabled]="isSubmitting()"
            (click)="onDisable()"
          >
            {{ "pluginManageDisconnectBtn" | i18n: plugin()?.title }}
          </button>
        </div>
      </div>
    }
  </div>
} @else {
  <!-- Details (available): DS 2.1 slide-out cards -->
  <div class="tw-flex tw-flex-col tw-gap-4 tw-pb-6" data-testid="plugin-details">
    <div class="tw-flex tw-items-center tw-gap-3.5">
      <span
        class="tw-flex tw-items-center tw-justify-center tw-size-11 tw-shrink-0 tw-rounded-[14px] tw-bg-color-surface-sunken tw-text-sm tw-font-semibold tw-text-color-text-secondary"
        >{{ monogram }}</span
      >
      <span
        class="tw-flex-1 tw-min-w-0 tw-truncate tw-text-xs tw-font-medium tw-text-color-text-tertiary"
        >{{ detailsSubtitle }}</span
      >
      <span
        class="tw-flex tw-items-center tw-h-7 tw-px-3 tw-rounded-full tw-bg-color-surface-sunken tw-text-xs tw-font-semibold tw-text-color-text-secondary"
        >{{ plugin()?.price || "Free" }}</span
      >
    </div>

    <div
      class="tw-flex tw-flex-col tw-gap-2.5 tw-p-4 tw-rounded-2xl tw-bg-white/45 tw-border tw-border-solid tw-border-white/40 tw-text-[13px] tw-leading-[1.5] tw-text-color-text-secondary"
    >
      <span
        class="tw-text-[11px] tw-font-bold tw-uppercase tw-tracking-[0.08em] tw-text-color-text-tertiary"
        >Overview</span
      >
      <span>{{ plugin()?.description }}</span>
    </div>

    <div
      class="tw-flex tw-flex-col tw-gap-2.5 tw-p-4 tw-rounded-2xl tw-bg-white/45 tw-border tw-border-solid tw-border-white/40 tw-text-[13px] tw-leading-[1.5] tw-text-color-text-secondary"
    >
      <span
        class="tw-text-[11px] tw-font-bold tw-uppercase tw-tracking-[0.08em] tw-text-color-text-tertiary"
        >{{ "pluginManageDetails" | i18n }}</span
      >
      <div class="tw-grid tw-grid-cols-2 xs:tw-grid-cols-1 tw-gap-x-4 tw-gap-y-2.5">
        <div class="tw-flex tw-flex-col">
          <span class="tw-text-[11px] tw-font-semibold tw-text-color-text-tertiary">Version</span
          ><b class="tw-text-sm tw-font-medium tw-text-color-text-default">{{
            plugin()?.version || "1.0.0"
          }}</b>
        </div>
        <div class="tw-flex tw-flex-col">
          <span class="tw-text-[11px] tw-font-semibold tw-text-color-text-tertiary">Developer</span
          ><b class="tw-text-sm tw-font-medium tw-text-color-text-action">{{ developerName }}</b>
        </div>
        <div class="tw-flex tw-flex-col">
          <span class="tw-text-[11px] tw-font-semibold tw-text-color-text-tertiary">Size</span
          ><b class="tw-text-sm tw-font-medium tw-text-color-text-default">{{
            plugin()?.size || "—"
          }}</b>
        </div>
        <div class="tw-flex tw-flex-col">
          <span class="tw-text-[11px] tw-font-semibold tw-text-color-text-tertiary">Contact</span>
          @if (isBetaUser) {
            <a
              href="mailto:support@ironflytechnologies.com"
              class="tw-text-sm tw-font-medium tw-text-color-text-action tw-underline tw-break-all"
              >support&#64;ironflytechnologies.com</a
            >
          } @else {
            <b class="tw-text-sm tw-font-medium tw-text-color-text-action tw-break-all"
              >support&#64;ironflytechnologies.com</b
            >
          }
        </div>
        <div class="tw-flex tw-flex-col">
          <span class="tw-text-[11px] tw-font-semibold tw-text-color-text-tertiary"
            >Last updated</span
          ><b class="tw-text-sm tw-font-medium tw-text-color-text-default">{{
            plugin()?.lastUpdated || "5th Jan 2026"
          }}</b>
        </div>
        <div class="tw-flex tw-flex-col">
          <span class="tw-text-[11px] tw-font-semibold tw-text-color-text-tertiary">Price</span
          ><b class="tw-text-sm tw-font-medium tw-text-color-text-default">{{
            plugin()?.price || "Free"
          }}</b>
        </div>
      </div>
    </div>

    <div
      class="tw-flex tw-flex-col tw-gap-2.5 tw-p-4 tw-rounded-2xl tw-bg-white/45 tw-border tw-border-solid tw-border-white/40 tw-text-[13px] tw-leading-[1.5] tw-text-color-text-secondary"
      data-testid="plugin-details-permissions"
    >
      <span
        class="tw-text-[11px] tw-font-bold tw-uppercase tw-tracking-[0.08em] tw-text-color-text-tertiary"
        >What it will be able to do</span
      >
      @if (plugin()?.permissions && plugin().permissions.length > 0) {
        @for (permission of plugin().permissions; track permission) {
          <div class="tw-flex tw-items-start tw-gap-2.5">
            <icon
              class="tw-mt-0.5"
              [name]="'check-only'"
              [size]="4"
              [currentColor]="'color-status-success-text'"
              [disableArrowOverride]="true"
            ></icon>
            <b class="tw-text-sm tw-font-medium tw-text-color-text-default">{{ permission }}</b>
          </div>
        }
      } @else {
        <span class="tw-text-color-text-tertiary tw-italic">No special permissions required.</span>
      }
      <span
        >"{{ plugin()?.title }}" collects this data to provide its functionality. For more details,
        please review the developer's privacy policy.</span
      >
    </div>

    @if (plugin()?.id === eodhdPluginId) {
      <div
        class="tw-flex tw-flex-col tw-gap-2.5 tw-p-4 tw-rounded-2xl tw-bg-white/45 tw-border tw-border-solid tw-border-white/40 tw-text-[13px] tw-leading-[1.5] tw-text-color-text-secondary"
      >
        <span class="tw-font-medium tw-text-color-text-default">{{
          "eodhdConfiguration" | i18n
        }}</span>
        <form [formGroup]="apiKeyForm" class="tw-flex tw-flex-col tw-gap-2">
          <div class="tw-flex tw-flex-col tw-gap-1">
            <label for="eodhdApiKey" class="tw-font-medium tw-text-sm tw-text-color-text-default">
              {{ "eodhdApiKeyLabel" | i18n }}
              <span class="tw-text-color-status-error-text">*</span>
            </label>
            <input
              id="eodhdApiKey"
              type="password"
              formControlName="apiKey"
              [placeholder]="'enterEodhdApiKey' | i18n"
              class="tw-px-3 tw-py-2 tw-border tw-border-solid tw-border-dt-border-primary tw-rounded-md focus:tw-outline-none focus:tw-ring-2 focus:tw-ring-color-icon-action"
              [class.!tw-border-color-status-error]="
                apiKeyForm.get('apiKey')?.invalid && apiKeyForm.get('apiKey')?.touched
              "
            />
            @if (apiKeyForm.get("apiKey")?.invalid && apiKeyForm.get("apiKey")?.touched) {
              <span class="tw-whitespace-nowrap tw-text-color-status-error-text tw-text-xs">{{
                "apiKeyIsRequired" | i18n
              }}</span>
            }
          </div>
        </form>
      </div>
    }

    <div
      class="tw-flex tw-items-center tw-justify-end tw-gap-3 tw-pt-4 tw-border-0 tw-border-t tw-border-solid tw-border-color-border-subtle"
      data-testid="plugin-details-footer"
    >
      <button
        type="button"
        class="tw-flex tw-items-center tw-gap-1.5 tw-h-10 tw-px-5 tw-rounded-xl tw-bg-color-surface-card tw-text-sm tw-font-semibold tw-text-color-text-action tw-shadow-elevation-control"
        [attr.aria-pressed]="!!plugin()?.isLiked"
        data-testid="plugin-details-save"
        (click)="toggleSaved()"
      >
        @if (plugin()?.isLiked) {
          <icon [name]="'check-only'" [size]="4" [disableArrowOverride]="true"></icon>
          {{ "pluginTabSaved" | i18n }}
        } @else {
          {{ "pluginsSaveForLater" | i18n }}
        }
      </button>
      <button
        type="button"
        class="tw-h-10 tw-px-5 tw-rounded-xl tw-bg-color-intent-brand tw-text-sm tw-font-semibold tw-text-color-text-on-action tw-shadow-elevation-control disabled:tw-opacity-60"
        [disabled]="isSubmitting()"
        data-testid="plugin-details-install"
        (click)="onInstall()"
      >
        {{ "pluginsInstall" | i18n }}
      </button>
    </div>
  </div>
}
